import styled from 'styled-components';

// Container for icons
export const IconContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${props => props.$isLoading ? 0.7 : 1};
  z-index: 2;
`;
